import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import { Precompra } from '../models/precompra';




@Injectable({
  providedIn: 'root'
})
export class PrecompraService {

  constructor(
    public http: HttpClient
  ) { }


  crearprepago( precompra: Precompra, idultimacompra: string ) {
   // console.log ('dato pasado', idultimacompra);
    const url = URL_SERVICIOS + '/precompra/' + idultimacompra;
    return this.http.post ( url , precompra)
    .map (( resp: any ) => {
      return resp.precompras;
    });

  }



  buscamovimiento(idmovimiento: string ) {
    const url = URL_SERVICIOS + '/precompra/' + idmovimiento;
    return this.http.get <any>( url);


  }




  ultimomovimiento(idempresa: string) {
    let url = URL_SERVICIOS + '/precompra/ultimomovimiento/' + idempresa;
    return this.http.get ( url)
    .map (( resp: any ) => {
      return resp;
    });

  }



  ultimomovimientoagencia(idempresa: string, tipolicencia:string) {
    let url = URL_SERVICIOS + '/precompra/ultimomovimientoagencias/' + idempresa +'/' + tipolicencia;
    return this.http.get ( url)
    .map (( resp: any ) => {
      return resp;
    });

  }


  buscaultimaprecompra(idempresa: string) {

    let url = URL_SERVICIOS + '/precompra/buscaultimaprecompra/' + idempresa;
    return this.http.get ( url)
    .map (( resp: any ) => {
      return resp;
    });

  }


  buscaultimaprecompraagencia(idempresa: string, tlicencia: string) {

    let url = URL_SERVICIOS + '/precompra/buscaultimaprecompraagencia/' + idempresa + "/" + tlicencia;
    return this.http.get ( url)
    .map (( resp: any ) => {
      return resp;
    });

  }
}
